import "core-js/modules/es.array.reverse.js";
var _class, _MapboxStyleCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import MapboxStyleImageryProvider from "terriajs-cesium/Source/Scene/MapboxStyleImageryProvider";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import MapboxStyleCatalogItemTraits from "../../../Traits/TraitsClasses/MapboxStyleCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";

/**
 *  A raster catalog item for rendering styled mapbox layers.
 */
let MapboxStyleCatalogItem = (_class = (_MapboxStyleCatalogItem = class MapboxStyleCatalogItem extends MappableMixin(CatalogMemberMixin(CreateModel(MapboxStyleCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", MapboxStyleCatalogItem.type);
    makeObservable(this);
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get imageryProvider() {
    const styleId = this.styleId;
    const accessToken = this.accessToken;
    if (styleId === undefined || accessToken === undefined) {
      return;
    }
    const imageryProvider = new MapboxStyleImageryProvider({
      url: this.url,
      username: this.username,
      styleId,
      accessToken,
      tilesize: this.tilesize,
      //Cesium only checks if scaleFactor is definied or not.
      scaleFactor: this.scaleFactor ? this.scaleFactor : undefined,
      minimumLevel: this.minimumLevel,
      maximumLevel: this.maximumLevel,
      credit: this.attribution
    });
    return imageryProvider;
  }
  get mapItems() {
    const imageryProvider = this.imageryProvider;
    if (imageryProvider === undefined) {
      return [];
    }
    const imageryPart = {
      imageryProvider,
      show: this.show,
      alpha: this.opacity,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    };
    return [imageryPart];
  }
}, _defineProperty(_MapboxStyleCatalogItem, "type", "mapbox-style"), _MapboxStyleCatalogItem), _applyDecoratedDescriptor(_class.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageryProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
export { MapboxStyleCatalogItem as default };